$( document ).ready(function() {

  getCart()
  function getCart(){
    // jQuery.getJSON('/cart.js', function(cart) {
       // now have access to Shopify cart object
      //  var data_cart_items = cart.items;
      // var needUpload = true;
      // var productResep = false;
      // var arrayButuhResep = [];

      // $(data_cart_items).each(function(index){
      //   var properties = data_cart_items[index].properties;
      //   var dataProduct = this;

      //   $.each(properties, function(keyName, keyValue) {
      //     if(keyName == 'Upload Resep'){
      //       var needUploaddata = false;
      //       needUpload = needUploaddata;
      //       return false;
      //     }
      //   });

      //   $.each(properties, function(keyName, keyValue) {
      //     if(keyName == 'Butuh Resep'){
      //       var productResepData = true;
      //       productResep = productResepData;
      //       var id = dataProduct.variant_id;
      //       arrayButuhResep.push(id);

      //     }
      //   });

      // });
    
      // if(needUpload == false){
      //   $('.custom-content-resep, .product-actions-buy-now.dapatkan_resep').hide(200);
      //   $('body').find('.product-form--atc-button').removeClass('upload_resep_first');
      // }else{
      //   $('#butuh-resep').remove();
      //   if(productResep == true){
      //     removeItems(arrayButuhResep);
      //   }
      //   $('.custom-content-resep, .product-actions-buy-now.dapatkan_resep').show(200);
      //   $('body').find('.product-form--atc-button').addClass('upload_resep_first');
      // }


    // } );
  }

  // function removeItems(items){
  //     var itemsProcessed = items;
  //     var itemsArray = items;
  //     var qty = 0;
  //     var data = { updates: {} };
     
  //     for (i = 0; i < itemsArray.length; i++) {
  //        data.updates[itemsArray[i]] = qty;
  //     }
    
  //     jQuery.ajax({
  //       type: 'POST',
  //       url: '/cart/update.js',
  //       data: data,
  //       dataType: 'json',
  //       success: function() { 
  //         location.reload();
  //       }
  //     });
    
  // }

});